jQuery(function () {
    var kidsSingular = window.ppt.translate("kid", "Kind");
    var kidsPlural = window.ppt.translate("kids", "Kinder");

    $(".kids-picker-section").on("change", ".kids-count", function (e) {
        var $this = $(this);
        privateFunctions.timedChangeAmount($this);
    });
    $(".kids-picker-section").on("click", ".kids-count-button.increase", function (e) {
        e.preventDefault();
        var $this = $(this);
        var input = $this.parent().find(".kids-count");
        var currentString = input.val();
        currentString = currentString.split(" ");
        var current = currentString[0];

        if(isNaN(current)) {
            return;
        }
        current = parseInt(current);
        if(current >= 9) {
            return
        }
        current += 1;

        var $pickerSection = $(this).parent().parent();

        if(current == 1){
            input.val(current + " " + kidsSingular);
        }
        else{
            input.val(current + " " + kidsPlural);
        }

        for(var i = 1; i<= current; i++){
            $pickerSection.find("#kids-age-container-"+ i).removeClass("hide");
        }
    });
    $(".kids-picker-section").on("click", ".kids-count-button.decrease", function (e) {
        e.preventDefault();
        var $this = $(this);
        var input = $this.parent().find(".kids-count");
        var currentString = input.val();
        currentString = currentString.split(" ");
        var current = currentString[0];

        if(isNaN(current)) {
            return;
        }
        current = parseInt(current);
        if(current <= 1) {
            return;
        }
        current -= 1;

        var $pickerSection = $(this).parent().parent();

        if(current == 1){
            input.val(current + " " + kidsSingular);
        }
        else{
            input.val(current + " " + kidsPlural);
        }

        for(var i = 9; i> current; i--){
            $pickerSection.find("#kids-age-container-"+ i).addClass("hide");
        }
    });


    $('#familypass-newsletter'). click(function(){
        var $this = $(this);

        if($(this). prop("checked") == true){
            console.log("Checkbox is checked." );

            $("#email-familypass-newsletter").attr("required", true);
            $("#email-familypass-newsletter").next(".icon-asterisk").removeClass("hide");
        }
        else if($(this). prop("checked") == false) {
            console.log("Checkbox is unchecked.");

            $("#email-familypass-newsletter").attr("required", false);
            $("#email-familypass-newsletter").next(".icon-asterisk").addClass("hide");

            // remove invalid status
            $("#email-familypass-newsletter").removeClass("is-invalid-input");
            $("#email-familypass-newsletter" ).removeAttr( "data-invalid" );
        }
    });

});